/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Category } from './Category';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
    CategoryToJSONTyped,
} from './Category';

/**
 * 
 * @export
 * @interface Domain
 */
export interface Domain {
    /**
     * 
     * @type {number}
     * @memberof Domain
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    title?: string;
    /**
     * 
     * @type {Array<Category>}
     * @memberof Domain
     */
    Categories?: Array<Category>;
}

/**
 * Check if a given object implements the Domain interface.
 */
export function instanceOfDomain(value: object): value is Domain {
    return true;
}

export function DomainFromJSON(json: any): Domain {
    return DomainFromJSONTyped(json, false);
}

export function DomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): Domain {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'Categories': json['Categories'] == null ? undefined : ((json['Categories'] as Array<any>).map(CategoryFromJSON)),
    };
}

  export function DomainToJSON(json: any): Domain {
      return DomainToJSONTyped(json, false);
  }

  export function DomainToJSONTyped(value?: Domain | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'Categories': value['Categories'] == null ? undefined : ((value['Categories'] as Array<any>).map(CategoryToJSON)),
    };
}

